module.exports = __webpack_public_path__ + "static/media/home-blue.f01a52eb.svg";